import { render, staticRenderFns } from "./UpdateProfileRequestEditForm.vue?vue&type=template&id=ed40cdf0&"
import script from "./UpdateProfileRequestEditForm.vue?vue&type=script&lang=js&"
export * from "./UpdateProfileRequestEditForm.vue?vue&type=script&lang=js&"
import style0 from "./UpdateProfileRequestEditForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports